/**
 * Canonical public marketing site (clareefai.com).
 *
 * Public share / copy links MUST point here — NOT at the vendor SPA origin
 * (vendor.clareefai.com). The marketing site server-renders the /review,
 * /use-case and /company pages with Open Graph preview images, whereas the
 * vendor /review and /public-use-case routes only client-side-redirect, which
 * social crawlers (LinkedIn, Facebook, WhatsApp, Slack…) never follow — so a
 * vendor-origin link previews with no image.
 *
 * Overridable via VITE_PUBLIC_SITE_URL for staging/local.
 */
export const PUBLIC_SITE_URL =
  import.meta.env.VITE_PUBLIC_SITE_URL ?? 'https://clareefai.com';
